<template lang="html">
  <div class="checkout__stepwrapper">
    <form @submit.prevent id="checkout_form">
      <fieldset class="input-group flex flex-row flex-wrap mb-4">
        <div class="w-full">
          <span class="text-lg font-bold border-b border-[#dee2e6] block pb-1">Persoonsgegevens</span>
        </div>
        <div class="w-full lg:w-1/2 lg:pr-1.5 pt-3">
          <input v-model="persoonsgegevens.voornaam" @focus="persoonsgegevensErrors.voornaam = ''" class="input-basics w-full" :class="[(persoonsgegevens.voornaam.length > 0 ? (/^[a-zA-Z]*$/).test(persoonsgegevens.voornaam) ? 'border border-td-dark-green-100' : 'border border-red-600' : ''), persoonsgegevensErrors.voornaam]" type="text" name="voornaam" placeholder="Voornaam *" required />
        </div>
        <div class="w-full lg:w-1/2 lg:pl-1.5 pt-3">
          <input v-model="persoonsgegevens.achternaam" @focus="persoonsgegevensErrors.achternaam = ''" class="input-basics w-full" :class="[(persoonsgegevens.achternaam.length > 0 ? (/^[a-zA-Z]*$/).test(persoonsgegevens.achternaam) ? 'border border-td-dark-green-100' : 'border border-red-600' : ''), persoonsgegevensErrors.achternaam]" type="text" name="achternaam" placeholder="Achternaam *" required />
        </div>
        <div class="w-full pt-3">
          <input v-model="persoonsgegevens.bedrijfsmail" @focus="persoonsgegevensErrors.bedrijfsmail = ''" class="input-basics w-full" :class="[(persoonsgegevens.bedrijfsmail.length > 0 ? (/^\S+@\S+\.\S+$/).test(persoonsgegevens.bedrijfsmail) ? 'border border-td-dark-green-100' : 'border border-red-600' : ''), persoonsgegevensErrors.bedrijfsmail]" type="mail" name="mail" placeholder="E-mailadres *" required />
        </div>
        <div class="w-full pt-3">
          <input v-model="persoonsgegevens.telefoonnummer" @focus="persoonsgegevensErrors.telefoonnummer = ''" class="input-basics w-full" :class="persoonsgegevens.telefoonnummer.length > 0 ? (/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i).test(persoonsgegevens.telefoonnummer) ? 'border border-td-dark-green-100' : 'border border-red-600' : ''" type="text" name="telefoonnummer" placeholder="Telefoonnummer" required />
        </div>
        <div class="w-full pt-3">
          <input v-model="persoonsgegevens.bedrijf" @focus="persoonsgegevensErrors.bedrijf = ''" class="input-basics w-full" :class="persoonsgegevens.bedrijf.length > 0 ? (/^[a-zA-Z]*$/).test(persoonsgegevens.bedrijf) ? 'border border-td-dark-green-100' : 'border border-red-600' : ''" type="text" name="bedrijf" placeholder="Bedrijf" required />
        </div>
        <div class="w-full pt-3" v-if="pageType === 'inschrijven'">
          <input v-model="persoonsgegevens.adres" @focus="persoonsgegevensErrors.adres = ''" class="input-basics w-full" :class="[(persoonsgegevens.adres.length > 0 ? (/^[#.0-9a-zA-Z\s,-]+$/).test(persoonsgegevens.adres) ? 'border border-td-dark-green-100' : 'border border-red-600' : ''),  persoonsgegevensErrors.adres]" type="text" name="straat" placeholder="Straat met huisnr. *" required />
        </div>
        <div class="w-full lg:w-1/2 lg:pr-1.5 pt-3" v-if="pageType === 'inschrijven'">
          <input v-model="persoonsgegevens.plaats" @focus="persoonsgegevensErrors.plaats = ''" class="input-basics w-full" :class="[(persoonsgegevens.plaats.length > 0 ? (/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/).test(persoonsgegevens.plaats) ? 'border border-td-dark-green-100' : 'border border-red-600' : ''),  persoonsgegevensErrors.plaats]" type="text" name="plaats" placeholder="Plaats *" required />
        </div>
        <div class="w-full lg:w-1/2 lg:pl-1.5 pt-3" v-if="pageType === 'inschrijven'">
          <input v-model="persoonsgegevens.postcode" @focus="persoonsgegevensErrors.postcode = ''" class="input-basics w-full" :class="[(persoonsgegevens.postcode.length > 0 ? (/^[1-9][0-9]{3} ?(?!sa|sd|ss|SA|SD|SS)[A-Za-z]{2}$/).test(persoonsgegevens.postcode) ? 'border border-td-dark-green-100' : 'border border-red-600' : ''),  persoonsgegevensErrors.postcode]" type="text" name="postcode" placeholder="Postcode *" required />
        </div>
      </fieldset>

      <fieldset class="input-group flex flex-row flex-wrap mb-4" v-if="pageType === 'inschrijven'">
        <div class="w-full">
          <span class="text-lg font-bold border-b border-[#dee2e6] block pb-1">Factuurgegevens</span>
        </div>
        <div class="w-full pt-3">
          <input v-model="factuurgegevens.otherAddress" @change="factuurgegevens.adres = '', factuurgegevens.plaats = '', factuurgegevens.postcode = ''" class="appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-td-orange-100 checked:border-td-orange-100 focus:outline-none transition duration-200 mt-2 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" id="factuuradres">
          <label class="form-check-label" for="factuuradres">Gebruik een ander factuuradres</label>
        </div>
        <div class="w-full pt-3" v-show="factuurgegevens.otherAddress === true">
          <input v-model="factuurgegevens.adres" @focus="factuurgegevensErrors.adres = ''" class="input-basics w-full" :class="[(factuurgegevens.adres.length > 0 ? (/^[#.0-9a-zA-Z\s,-]+$/).test(factuurgegevens.adres) ? 'border border-td-dark-green-100' : 'border border-red-600' : ''), factuurgegevensErrors.adres]" type="text" name="straat" placeholder="Straat met huisnr. *" required />
        </div>
        <div class="w-full lg:w-1/2 lg:pr-1.5 pt-3" v-show="factuurgegevens.otherAddress === true">
          <input v-model="factuurgegevens.plaats" @focus="factuurgegevensErrors.plaats = ''" class="input-basics w-full" :class="[(factuurgegevens.plaats.length > 0 ? (/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/).test(factuurgegevens.plaats) ? 'border border-td-dark-green-100' : 'border border-red-600' : ''), factuurgegevensErrors.plaats]" type="text" name="plaats" placeholder="Plaats *" required />
        </div>
        <div class="w-full lg:w-1/2 lg:pl-1.5 pt-3" v-show="factuurgegevens.otherAddress === true">
          <input v-model="factuurgegevens.postcode" @focus="factuurgegevensErrors.postcode = ''" class="input-basics w-full" :class="[(factuurgegevens.postcode.length > 0 ? (/^[1-9][0-9]{3} ?(?!sa|sd|ss|SA|SD|SS)[A-Za-z]{2}$/).test(factuurgegevens.postcode) ? 'border border-td-dark-green-100' : 'border border-red-600' : ''), factuurgegevensErrors.postcode]" type="text" name="postcode" placeholder="Postcode *" required />
        </div>
        <div class="w-full pt-3">
          <input v-model="factuurgegevens.tav" class="input-basics w-full" :class="factuurgegevens.tav.length > 0 ? (/^[a-zA-Z ]*$/).test(factuurgegevens.tav) ? 'border border-td-dark-green-100' : 'border border-red-600' : ''" type="text" name="tav" placeholder="Factuur t.a.v." />
        </div>
        <div class="w-full pt-3">
          <input v-model="factuurgegevens.factuurmail" @focus="factuurgegevensErrors.factuurmail = ''" class="input-basics w-full" :class="[(factuurgegevens.factuurmail.length > 0 ? (/^\S+@\S+\.\S+$/).test(factuurgegevens.factuurmail) ? 'border border-td-dark-green-100' : 'border border-red-600' : ''), factuurgegevensErrors.factuurmail]" type="mail" name="factuuremail" placeholder="Factuur e-mailadres *" required />
        </div>
      </fieldset>

      <fieldset class="input-group flex flex-row flex-wrap mb-4">
        <div class="w-full">
          <span class="text-lg font-bold border-b border-[#dee2e6] block pb-1">Overig</span>
        </div>
        <div class="w-full pt-3">
          <textarea v-model="overig.opmerking" class="input-basics w-full" :class="overig.opmerking.length > 0 ? 'is-valid' : ''" rows="3" name="opmerking" placeholder="Eventuele opmerking" />
        </div>
         <div class="w-full pt-3">
          <input v-model="overig.acceptsTerms" class="appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-td-orange-100 checked:border-td-orange-100 focus:outline-none transition duration-200 mt-2 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" id="terms">
          <label class="form-check-label w-full" for="terms">Ik ga akkoord met de <a class="text-td-orange-100" href="/privacyvoorwaarden/" target="_blank">privacy voorwaarden</a> van Teach Digital, de genoemde investeringen en annuleringsregeling.</label>
        </div>
      </fieldset>

    </form>
  </div>
</template>     

<script>
export default {
  name: 'Step2',
  props: {
    partners: {
      type: Array,
      default: () => [],
    },
    pageType: {
      type: String,
      default: '',
      required: true,
    },
  },
  watch: {
    persoonsgegevens: {
      handler(val) {
        this.$emit('persoonsgegevens', val);
        this.checkReady();
      },
      deep: true
    },
    factuurgegevens: {
      handler(val) {
        this.$emit('factuurgegevens', val);
        this.checkReady();
      },
      deep: true
    },
    overig: {
      handler(val) {
        this.$emit('overig', val);
        this.checkReady();
      },
      deep: true
    },
  },
  data() {
    return {
      persoonsgegevensErrors: {
        voornaam: '',
        achternaam: '',
        bedrijfsmail: '',
        adres: '',
        plaats: '',
        postcode: ''
      },
      factuurgegevensErrors: {
        factuurmail: '',
        adres: '',
        plaats: '',
        postcode: ''
      },
      persoonsgegevens: {
        voornaam: '',
        achternaam: '',
        bedrijfsmail: '',
        telefoonnummer: '',
        bedrijf: '',
        adres: '',
        plaats: '',
        postcode: ''
      },
      factuurgegevens: {
        otherAddress: false,
        tav: '',
        factuurmail: '',
        adres: '',
        plaats: '',
        postcode: ''
      },
      overig: {
        opmerking: '',
        acceptsTerms: false,
      }
    }
  },
  methods: {
    checkInputs() {
      let ready = false;

      for (const [key, value] of Object.entries(this.persoonsgegevens)) {
        if (value === '') {
          if (this.pageType === 'offerte-aanvragen' && key !== 'adres' && key !== 'postcode' && key !== 'plaats' && key !== 'bedrijf' && key !== 'telefoonnummer') {
            this.persoonsgegevensErrors[key] = 'border border-red-600';
            ready = false;
          } else if ( (this.pageType === 'inschrijven') && (key === 'voornaam' || key === 'achternaam' || key === 'adres' || key === 'bedrijfsmail' || key === 'plaats' || key === 'postcode')) {
            this.persoonsgegevensErrors[key] = 'border border-red-600';
            ready = false;
          } else {
            ready = true;
          }
        } else {
          ready = true
        }
      }

      if (this.pageType !== 'offerte-aanvragen') {
        for (const [key, value] of Object.entries(this.factuurgegevens)) {
          if (value === '') {
            ready = false;
            this.factuurgegevensErrors[key] = 'border border-red-600';
          } else {
            ready = true;
          }
        }
      }

      return ready;
    },
    checkReady() {
      let ready = true;

      for (const [key, value] of Object.entries(this.persoonsgegevens)) {
        if (value === '') ready = false;
      }

      if (this.pageType === 'offerte-aanvragen') {
        this.factuurgegevens.adres = this.persoonsgegevens.adres;
        this.factuurgegevens.plaats = this.persoonsgegevens.plaats;
        this.factuurgegevens.postcode = this.persoonsgegevens.postcode;
        this.factuurgegevens.factuurmail = this.persoonsgegevens.bedrijfsmail;
      }
      else if (this.factuurgegevens.otherAddress === false) {
        this.factuurgegevens.adres = this.persoonsgegevens.adres;
        this.factuurgegevens.plaats = this.persoonsgegevens.plaats;
        this.factuurgegevens.postcode = this.persoonsgegevens.postcode;
      } else {
        if (this.factuurgegevens.postcode === '') ready = false;
        if (this.factuurgegevens.plaats === '') ready = false;
        if (this.factuurgegevens.adres === '') ready = false;
      }

      if (this.factuurgegevens.factuurmail.length < 2) ready = false;

      if (this.factuurgegevens.factuurmail === '') ready = false;
      if (this.overig.acceptsTerms === false) ready = false;

      let form = document.querySelector('#checkout_form');
      let inputs = form.querySelectorAll('.input-basics');
      inputs.forEach((input) => {
        if (input.classList.contains('border-red-600')) ready = false;
      })

      this.$emit('ready', ready);
    }
  }
}
</script>
